import React, { useState, useEffect, useCallback } from 'react';
import SearchWidget from '../../../shared/components/SearchWidget';
import tourvisorAPI from '../../api/tourvisorAPI';

export const actypesData = [
  { id: '91', searchId: 1, name: 'Апартаменты', group: 'Тип размещения' },
  { id: '92', searchId: 2, name: 'Вилла', group: 'Тип размещения' },
  { id: '93', searchId: 3, name: 'Санаторий', group: 'Тип размещения' },
  { id: '94', searchId: 4, name: 'Пансионат', group: 'Тип размещения' },
  { id: '95', searchId: 5, name: 'База отдыха', group: 'Тип размещения' },
  { id: '96', searchId: 6, name: 'Гостевой дом', group: 'Тип размещения' },
];

const Services = ({
  valueServices = [],
  valueActypes = [],
  onChooseServices,
  onChooseActypes,
}) => {
  const [services, setServices] = useState(valueServices);
  const [actypes, setActypes] = useState(valueActypes);
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState('Выберите услуги');
  const [wasChange, setWasChanged] = useState(false);

  useEffect(() => {
    getServices({});
  }, []);

  useEffect(() => {
    if ([...valueActypes, ...valueServices].length === 1) {
      const serv = items.find((item) => item.id === services[0]);
      const hotelType = items.find((item) => item.id === actypes[0]);
      if (serv?.name?.length < 22) {
        setTitle(serv.name);
      } else if (hotelType?.name?.length < 22) {
        setTitle(hotelType.name);
      } else {
        setTitle(`Выбрана 1 услуга`);
      }
    } else if ([...valueActypes, ...valueServices].length === 0) {
      setTitle('Выберите услуги');
    } else if ([...valueActypes, ...valueServices].length < 5) {
      setTitle(`Выбрано ${[...valueActypes, ...valueServices].length} услуги`);
    } else if ([...valueActypes, ...valueServices].length > 4) {
      setTitle(`Выбрано ${[...valueActypes, ...valueServices].length} услуг`);
    } else if ([...valueActypes, ...valueServices].length) {
      setTitle(`Любой`);
    }
    setWasChanged([...valueActypes, ...valueServices].length > 0);
  }, [valueActypes, valueServices]);

  useEffect(() => {
    onChooseActypes(actypes);
  }, [actypes, onChooseActypes]);

  useEffect(() => {
    onChooseServices(services);
  }, [services, onChooseServices]);

  const getServices = async (params) => {
    let requestQuery = new URLSearchParams(params).toString();
    const res = await tourvisorAPI.dics('services', requestQuery);
    const servicesList = res.lists.services.service;
    actypesData.forEach((item) => {
      servicesList.push(item);
    });
    setItems(servicesList);
  };

  const resetHandler = () => {
    onChooseServices([]);
    onChooseActypes([]);
    setActypes([]);
    setServices([]);
    setTitle('Выберите услуги');
  };

  const setServicesOnChoose = useCallback((v) => {
    if (v * 1 > 90) {
      setActypes((prevActypes) => {
        const index = prevActypes.indexOf(v);

        if (index !== -1) {
          return prevActypes.filter((actype) => actype !== v);
        } else {
          return [...prevActypes, v];
        }
      });
    } else {
      setServices((prevServices) => {
        const index = prevServices.indexOf(v);

        if (index !== -1) {
          return prevServices.filter((service) => service !== v);
        } else {
          return [...prevServices, v];
        }
      });
    }
  }, []);

  return (
    <SearchWidget
      type="multiselect"
      label="услуги отеля"
      title={`${title}`}
      items={items}
      value={[...services, ...actypes]}
      cssClass={'services'}
      buttonReset={true}
      onReset={resetHandler}
      isChanged={wasChange}
      onChoose={setServicesOnChoose}
    />
  );
};

export default Services;
